import * as React from 'react';
import styled, {css} from 'styled-components';

export enum LinkVariant {
  Default = 'default',
  Primary = 'primary',
}

export interface LinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: LinkVariant;
}

const Container = styled.a<LinkProps>`
  cursor: pointer;
  
  ${({variant, theme}) => {
    switch (variant) {
      case LinkVariant.Default: return css`
        color: ${theme.variables.color};
      `;
      case LinkVariant.Primary: return css`
        color: ${theme.colors.primary};
      `;
    }
  }};
  
  &:hover,
  &:focus-visible {
    text-decoration: underline;
  }
  
  &::before,
  &::after {
    content: ' ';
  }
`;

/**
 * This component is a link.
 * @param {LinkProps} props
 * @return {React.ReactElement<LinkProps>}
 * @constructor
 */
function Link(
    props: LinkProps,
): React.ReactElement<LinkProps> {
  return <Container {...props} />;
}

Link.defaultProps = {
  variant: LinkVariant.Default,
};

export default Link;
